/**
 * Product Brief - Objet structuré modulaire remplaçant la description plate
 */

export interface ProductBriefBaseInfo {
  productName: string;
  brand: string;
  targetAudience?: string;
}

export interface ProductBriefPainPoint {
  problem: string;
  solution?: string;
}

export interface ProductBriefQAPair {
  question: string;
  answer: string;
}

export interface ProductBriefAssertion {
  assertion: string;
  result: string;
  nuance?: string;
}

export interface ProductBrief {
  baseInfo: ProductBriefBaseInfo;
  sellingPoints: string[];
  painPoints: ProductBriefPainPoint[];
  features: string[];
  freeformNotes?: string;
  qaPairs?: ProductBriefQAPair[];
  assertions?: ProductBriefAssertion[];
  specifications?: Record<string, string>;
  competitiveAdvantages?: string[];
}

export const createEmptyProductBrief = (): ProductBrief => ({
  baseInfo: { productName: "", brand: "" },
  sellingPoints: [],
  painPoints: [],
  features: [],
});
